import { Controller } from "stimulus";

export default class SelectFilterController extends Controller {
  static targets = ["content", "toggle"];

  change(event) {
    window.location = this.data.get("url") + `&filter=${event.target.value}`;
  }

  changeEvent(event) {
    const [optType, id] = event.target.value.split("_");

    if (optType === "series") {
      window.location = `/series_results/${id}`;
    } else {
      window.location = `/results/${id}`;
    }
  }

  toggleRuns(event) {
    event.currentTarget.nextElementSibling.classList.toggle("no-display");
  }

  toggleRunsSelf(event) {
    event.currentTarget.classList.toggle("no-display");
  }
}
